
import { toString, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { int32_type, union_type, list_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { StringBuilder_$ctor, StringBuilder__Append_244C7CD6, StringBuilder__Clear, StringBuilder__get_Length } from "../fable_modules/fable-library-js.5.13.0/System.Text.js";
import { forAll as forAll_1, append, skipWhile, tail, head, singleton, isEmpty, map, length, skip, takeWhile, empty, ofArray, filter, reverse, cons } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { replace, join, split, substring } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList, takeWhile as takeWhile_1, length as length_1, forAll } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { isDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { value as value_8 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { CSSProp } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { render as render_1 } from "./KeyCaps.js";

/**
 * Text with emphasis, within one paragraph, heading, list item or table cell.
 */
export class Inline extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Text", "Bold", "Italic", "Code", "Link", "Keys"];
    }
}

export function Inline_$reflection() {
    return union_type("Markdown.Inline", [], Inline, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["shown", string_type], ["url", string_type]], [["Item", list_type(string_type)]]]);
}

export class Block extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Heading", "Para", "Bullets", "Numbered", "Table"];
    }
}

export function Block_$reflection() {
    return union_type("Markdown.Block", [], Block, () => [[["level", int32_type], ["Item2", list_type(Inline_$reflection())]], [["Item", list_type(Inline_$reflection())]], [["Item", list_type(list_type(Inline_$reflection()))]], [["Item", list_type(list_type(Inline_$reflection()))]], [["header", list_type(list_type(Inline_$reflection()))], ["rows", list_type(list_type(list_type(Inline_$reflection())))]]]);
}

/**
 * Split a line into text and emphasis.
 * 
 * Written as a scan rather than with a regular expression per mark so that the marks cannot
 * interleave wrongly: at each position at most one of them can start, and each runs to its own
 * closing mark. An unclosed mark is not an error - it is left as literal text, which is what a
 * reader of the source would expect and what stops one stray asterisk swallowing a paragraph.
 */
export function parseInlines(line) {
    const n = line.length | 0;
    const closes = (mark, from) => {
        const matchValue = line.indexOf(mark, from) | 0;
        if (matchValue === -1) {
            return undefined;
        }
        else {
            return matchValue;
        }
    };
    const go = (i_1_mut, plain_mut, acc_mut) => {
        go:
        while (true) {
            const i_1 = i_1_mut, plain = plain_mut, acc = acc_mut;
            let close;
            const flush = (acc_1) => {
                if (StringBuilder__get_Length(plain) === 0) {
                    return acc_1;
                }
                else {
                    const t = toString(plain);
                    StringBuilder__Clear(plain);
                    return cons(new Inline(/* Text */ 0, [t]), acc_1);
                }
            };
            if (i_1 >= n) {
                return reverse(flush(acc));
            }
            else {
                const starts = (mark_1) => {
                    if ((i_1 + mark_1.length) <= n) {
                        return substring(line, i_1, mark_1.length) === mark_1;
                    }
                    else {
                        return false;
                    }
                };
                if (starts("**")) {
                    const matchValue_1 = closes("**", i_1 + 2);
                    if (matchValue_1 == null) {
                        StringBuilder__Append_244C7CD6(plain, line[i_1]);
                        i_1_mut = (i_1 + 1);
                        plain_mut = plain;
                        acc_mut = acc;
                        continue go;
                    }
                    else {
                        const j = matchValue_1 | 0;
                        i_1_mut = (j + 2);
                        plain_mut = plain;
                        acc_mut = cons(new Inline(/* Bold */ 1, [substring(line, i_1 + 2, (j - i_1) - 2)]), flush(acc));
                        continue go;
                    }
                }
                else if (starts("*")) {
                    const matchValue_2 = closes("*", i_1 + 1);
                    if (matchValue_2 == null) {
                        StringBuilder__Append_244C7CD6(plain, line[i_1]);
                        i_1_mut = (i_1 + 1);
                        plain_mut = plain;
                        acc_mut = acc;
                        continue go;
                    }
                    else {
                        const j_1 = matchValue_2 | 0;
                        i_1_mut = (j_1 + 1);
                        plain_mut = plain;
                        acc_mut = cons(new Inline(/* Italic */ 2, [substring(line, i_1 + 1, (j_1 - i_1) - 1)]), flush(acc));
                        continue go;
                    }
                }
                else if (starts("`")) {
                    const matchValue_3 = closes("`", i_1 + 1);
                    if (matchValue_3 == null) {
                        StringBuilder__Append_244C7CD6(plain, line[i_1]);
                        i_1_mut = (i_1 + 1);
                        plain_mut = plain;
                        acc_mut = acc;
                        continue go;
                    }
                    else {
                        const j_2 = matchValue_3 | 0;
                        i_1_mut = (j_2 + 1);
                        plain_mut = plain;
                        acc_mut = cons(new Inline(/* Code */ 3, [substring(line, i_1 + 1, (j_2 - i_1) - 1)]), flush(acc));
                        continue go;
                    }
                }
                else if (starts("[[")) {
                    const matchValue_4 = closes("]]", i_1 + 2);
                    if (matchValue_4 == null) {
                        StringBuilder__Append_244C7CD6(plain, line[i_1]);
                        i_1_mut = (i_1 + 1);
                        plain_mut = plain;
                        acc_mut = acc;
                        continue go;
                    }
                    else {
                        const j_3 = matchValue_4 | 0;
                        i_1_mut = (j_3 + 2);
                        plain_mut = plain;
                        acc_mut = cons(new Inline(/* Keys */ 5, [filter((s) => (s !== ""), ofArray(split(substring(line, i_1 + 2, (j_3 - i_1) - 2), [" "], undefined, 0)))]), flush(acc));
                        continue go;
                    }
                }
                else if (starts("[")) {
                    const matchValue_5 = closes("]", i_1 + 1);
                    let matchResult, close_1;
                    if (matchValue_5 != null) {
                        if ((close = (matchValue_5 | 0), ((close + 1) < n) && (line[close + 1] === "("))) {
                            matchResult = 0;
                            close_1 = matchValue_5;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0: {
                            const matchValue_6 = closes(")", close_1 + 2);
                            if (matchValue_6 == null) {
                                StringBuilder__Append_244C7CD6(plain, line[i_1]);
                                i_1_mut = (i_1 + 1);
                                plain_mut = plain;
                                acc_mut = acc;
                                continue go;
                            }
                            else {
                                const rp = matchValue_6 | 0;
                                i_1_mut = (rp + 1);
                                plain_mut = plain;
                                acc_mut = cons(new Inline(/* Link */ 4, [substring(line, i_1 + 1, (close_1 - i_1) - 1), substring(line, close_1 + 2, (rp - close_1) - 2)]), flush(acc));
                                continue go;
                            }
                        }
                        default: {
                            StringBuilder__Append_244C7CD6(plain, line[i_1]);
                            i_1_mut = (i_1 + 1);
                            plain_mut = plain;
                            acc_mut = acc;
                            continue go;
                        }
                    }
                }
                else {
                    StringBuilder__Append_244C7CD6(plain, line[i_1]);
                    i_1_mut = (i_1 + 1);
                    plain_mut = plain;
                    acc_mut = acc;
                    continue go;
                }
            }
            break;
        }
    };
    return go(0, StringBuilder_$ctor(), empty());
}

function spanWhile(pred, lst) {
    const taken = takeWhile(pred, lst);
    return [taken, skip(length(taken), lst)];
}

function tableCells(line) {
    const t = line.trim();
    const t_1 = t.startsWith("|") ? substring(t, 1) : t;
    return map((c) => parseInlines(c.trim()), ofArray(split(t_1.endsWith("|") ? substring(t_1, 0, t_1.length - 1) : t_1, ["|"], undefined, 0)));
}

function isTableRule(line) {
    const t = line.trim();
    if (t.startsWith("|")) {
        return forAll((c) => {
            if (((c === "|") ? true : (c === "-")) ? true : (c === ":")) {
                return true;
            }
            else {
                return c === " ";
            }
        }, t.split(""));
    }
    else {
        return false;
    }
}

function isTableRow(line) {
    return line.trim().startsWith("|");
}

function bulletText(line) {
    const t = line.trimStart();
    if (t.startsWith("- ")) {
        return substring(t, 2);
    }
    else if (t.startsWith("* ")) {
        return substring(t, 2);
    }
    else {
        return undefined;
    }
}

function numberedText(line) {
    const t = line.trimStart();
    const digits = length_1(takeWhile_1(isDigit, t.split(""))) | 0;
    if ((((digits > 0) && (t.length > (digits + 1))) && (t[digits] === ".")) && (t[digits + 1] === " ")) {
        return substring(t, digits + 2);
    }
    else {
        return undefined;
    }
}

function isBlockStart(line) {
    if ((((line.trim() === "") ? true : line.trimStart().startsWith("#")) ? true : isTableRow(line)) ? true : (bulletText(line) != null)) {
        return true;
    }
    else {
        return numberedText(line) != null;
    }
}

function listItems(marker, lines) {
    const go = (lines_1_mut, current_mut, items_mut) => {
        go:
        while (true) {
            const lines_1 = lines_1_mut, current = current_mut, items = items_mut;
            const close = (items_1) => {
                if (isEmpty(current)) {
                    return items_1;
                }
                else {
                    return cons(reverse(current), items_1);
                }
            };
            let matchResult, line_2, rest_2, line_3, rest_3;
            if (!isEmpty(lines_1)) {
                if (marker(head(lines_1)) != null) {
                    matchResult = 0;
                    line_2 = head(lines_1);
                    rest_2 = tail(lines_1);
                }
                else if (!isEmpty(current) && !isBlockStart(head(lines_1))) {
                    matchResult = 1;
                    line_3 = head(lines_1);
                    rest_3 = tail(lines_1);
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
            switch (matchResult) {
                case 0: {
                    lines_1_mut = rest_2;
                    current_mut = singleton(value_8(marker(line_2)));
                    items_mut = close(items);
                    continue go;
                }
                case 1: {
                    lines_1_mut = rest_3;
                    current_mut = cons(line_3.trim(), current);
                    items_mut = items;
                    continue go;
                }
                default:
                    return [reverse(close(items)), lines_1];
            }
            break;
        }
    };
    return go(lines, empty(), empty());
}

/**
 * Markdown to blocks.
 * 
 * Paragraphs are separated by blank lines and a wrapped paragraph is joined back into one line,
 * so the source can be wrapped to the column width the rest of the codebase uses without that
 * wrapping reaching the screen.
 */
export function parse(text) {
    const blocks = (lines_1_mut, acc_mut) => {
        blocks:
        while (true) {
            const lines_1 = lines_1_mut, acc = acc_mut;
            let matchResult, line_6, rest_3, line_7, rest_4, header_1, rest_5, rule_1, line_10, line_13, first, rest_6;
            if (!isEmpty(lines_1)) {
                if (head(lines_1).trim() === "") {
                    matchResult = 1;
                    line_6 = head(lines_1);
                    rest_3 = tail(lines_1);
                }
                else if (head(lines_1).trimStart().startsWith("#")) {
                    matchResult = 2;
                    line_7 = head(lines_1);
                    rest_4 = tail(lines_1);
                }
                else if (!isEmpty(tail(lines_1))) {
                    if (isTableRow(head(lines_1)) && isTableRule(head(tail(lines_1)))) {
                        matchResult = 3;
                        header_1 = head(lines_1);
                        rest_5 = tail(tail(lines_1));
                        rule_1 = head(tail(lines_1));
                    }
                    else if (bulletText(head(lines_1)) != null) {
                        matchResult = 4;
                        line_10 = head(lines_1);
                    }
                    else if (numberedText(head(lines_1)) != null) {
                        matchResult = 5;
                        line_13 = head(lines_1);
                    }
                    else {
                        matchResult = 6;
                        first = head(lines_1);
                        rest_6 = tail(lines_1);
                    }
                }
                else if (bulletText(head(lines_1)) != null) {
                    matchResult = 4;
                    line_10 = head(lines_1);
                }
                else if (numberedText(head(lines_1)) != null) {
                    matchResult = 5;
                    line_13 = head(lines_1);
                }
                else {
                    matchResult = 6;
                    first = head(lines_1);
                    rest_6 = tail(lines_1);
                }
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return reverse(acc);
                case 1: {
                    lines_1_mut = rest_3;
                    acc_mut = acc;
                    continue blocks;
                }
                case 2: {
                    const t = line_7.trimStart();
                    const level = length_1(takeWhile_1((y) => ("#" === y), t.split(""))) | 0;
                    lines_1_mut = rest_4;
                    acc_mut = cons(new Block(/* Heading */ 0, [min(level, 3), parseInlines(substring(t, level).trim())]), acc);
                    continue blocks;
                }
                case 3: {
                    const patternInput = spanWhile(isTableRow, rest_5);
                    lines_1_mut = patternInput[1];
                    acc_mut = cons(new Block(/* Table */ 4, [tableCells(header_1), map(tableCells, patternInput[0])]), acc);
                    continue blocks;
                }
                case 4: {
                    const patternInput_1 = listItems(bulletText, lines_1);
                    lines_1_mut = patternInput_1[1];
                    acc_mut = cons(new Block(/* Bullets */ 2, [map((arg) => parseInlines(join(" ", arg)), patternInput_1[0])]), acc);
                    continue blocks;
                }
                case 5: {
                    const patternInput_2 = listItems(numberedText, lines_1);
                    lines_1_mut = patternInput_2[1];
                    acc_mut = cons(new Block(/* Numbered */ 3, [map((arg_1) => parseInlines(join(" ", arg_1)), patternInput_2[0])]), acc);
                    continue blocks;
                }
                default: {
                    const patternInput_3 = spanWhile((l_1) => {
                        if ((((l_1.trim() !== "") && !l_1.trimStart().startsWith("#")) && !isTableRow(l_1)) && (bulletText(l_1) == null)) {
                            return numberedText(l_1) == null;
                        }
                        else {
                            return false;
                        }
                    }, rest_6);
                    lines_1_mut = patternInput_3[1];
                    acc_mut = cons(new Block(/* Para */ 1, [parseInlines(join(" ", map((l_2) => l_2.trim(), cons(first, patternInput_3[0]))))]), acc);
                    continue blocks;
                }
            }
            break;
        }
    };
    return blocks(skipWhile((l) => (l.trim() === ""), ofArray(split(replace(text, "\r\n", "\n"), ["\n"], undefined, 0))), empty());
}

function Styles_heading(level) {
    return ofArray([new CSSProp(/* FontWeight */ 165, ["bold"]), new CSSProp(/* FontSize */ 153, [(level === 1) ? "17px" : ((level === 2) ? "15px" : "14px")]), new CSSProp(/* MarginTop */ 226, ["14px"]), new CSSProp(/* MarginBottom */ 221, ["6px"])]);
}

const Styles_para = ofArray([new CSSProp(/* MarginBottom */ 221, ["10px"]), new CSSProp(/* LineHeight */ 213, ["1.45"])]);

const Styles_list = ofArray([new CSSProp(/* MarginBottom */ 221, ["10px"]), new CSSProp(/* MarginLeft */ 224, ["22px"]), new CSSProp(/* LineHeight */ 213, ["1.45"])]);

const Styles_item = singleton(new CSSProp(/* MarginBottom */ 221, ["4px"]));

const Styles_code = ofArray([new CSSProp(/* FontFamily */ 149, ["monospace"]), new CSSProp(/* BackgroundColor */ 21, ["rgba(0,0,0,0.06)"]), new CSSProp(/* Padding */ 273, ["1px 4px"]), new CSSProp(/* BorderRadius */ 69, ["3px"])]);

const Styles_cell = ofArray([new CSSProp(/* BorderBottom */ 42, ["1px solid #e0e0e0"]), new CSSProp(/* Padding */ 273, ["4px 10px 4px 0"]), new CSSProp(/* VerticalAlign */ 382, ["top"])]);

/**
 * One line's worth of inlines. `onLink` is given a link's url when it is clicked - see the note
 * at the top about why this module does not open it itself.
 */
export function renderInlines(onLink, inlines) {
    return map((_arg) => {
        switch (_arg.tag) {
            case 1:
                return react.createElement("b", {}, _arg.fields[0]);
            case 2:
                return react.createElement("i", {}, _arg.fields[0]);
            case 3: {
                const props_4 = [["style", keyValueList(Styles_code, 1)]];
                return react.createElement("span", keyValueList(props_4, 1), _arg.fields[0]);
            }
            case 4:
                return react.createElement("a", {
                    onClick: (_arg_1) => {
                        onLink(_arg.fields[1]);
                    },
                }, _arg.fields[0]);
            case 5:
                return render_1(_arg.fields[0]);
            default:
                return _arg.fields[0];
        }
    }, inlines);
}

/**
 * Rendered markdown, as one element ready to drop into a popup body.
 */
export function renderBlocks(onLink, blocks) {
    const inl = (inlines) => renderInlines(onLink, inlines);
    const items = (style, xs) => map((x) => {
        const props = [["style", keyValueList(Styles_item, 1)]];
        const children = inl(x);
        return react.createElement("li", keyValueList(props, 1), ...children);
    }, xs);
    const children_24 = map((_arg) => {
        switch (_arg.tag) {
            case 1: {
                const props_4 = [["style", keyValueList(Styles_para, 1)]];
                const children_4 = inl(_arg.fields[0]);
                return react.createElement("div", keyValueList(props_4, 1), ...children_4);
            }
            case 2: {
                const props_6 = [["style", keyValueList(append(Styles_list, singleton(new CSSProp(/* ListStyle */ 214, ["disc"]))), 1)]];
                const children_6 = items(Styles_item, _arg.fields[0]);
                return react.createElement("ul", keyValueList(props_6, 1), ...children_6);
            }
            case 3: {
                const props_8 = [["style", keyValueList(append(Styles_list, singleton(new CSSProp(/* ListStyle */ 214, ["decimal"]))), 1)]];
                const children_8 = items(Styles_item, _arg.fields[0]);
                return react.createElement("ol", keyValueList(props_8, 1), ...children_8);
            }
            case 4: {
                const header = _arg.fields[0];
                const headerIsBlank = forAll_1(isEmpty, header);
                const props_22 = [["style", {
                    borderCollapse: "collapse",
                    marginBottom: "12px",
                    width: "100%",
                }]];
                const children_22 = toList(delay(() => {
                    let children_14, children_12;
                    return append_1(!headerIsBlank ? singleton_1((children_14 = [(children_12 = map((c) => {
                        const props_10 = [["style", keyValueList(append(Styles_cell, singleton(new CSSProp(/* TextAlign */ 325, ["left"]))), 1)]];
                        const children_10 = inl(c);
                        return react.createElement("th", keyValueList(props_10, 1), ...children_10);
                    }, header), react.createElement("tr", {}, ...children_12))], react.createElement("thead", {}, ...children_14))) : empty_1(), delay(() => {
                        let children_20;
                        return singleton_1((children_20 = map((r) => {
                            const children_18 = map((c_1) => {
                                const props_16 = [["style", keyValueList(Styles_cell, 1)]];
                                const children_16 = inl(c_1);
                                return react.createElement("td", keyValueList(props_16, 1), ...children_16);
                            }, r);
                            return react.createElement("tr", {}, ...children_18);
                        }, _arg.fields[1]), react.createElement("tbody", {}, ...children_20)));
                    }));
                }));
                return react.createElement("table", keyValueList(props_22, 1), ...children_22);
            }
            default: {
                const props_2 = [["style", keyValueList(Styles_heading(_arg.fields[0]), 1)]];
                const children_2 = inl(_arg.fields[1]);
                return react.createElement("div", keyValueList(props_2, 1), ...children_2);
            }
        }
    }, blocks);
    return react.createElement("div", {}, ...children_24);
}

/**
 * Markdown text, rendered. The usual entry point.
 */
export function render(onLink, text) {
    return renderBlocks(onLink, parse(text));
}

